import { cloneDeep, parseInt } from 'lodash';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  DashboardHeader,
  useAppDispatch,
  useAppSelector,
  useEffectOnce,
  CustomForm, CustomButtonGroup, CustomBreadCrumbs, DashboardLoader, CustomRadioForm, FilterProp, CheckBox,
  SidePopover
} from '../../globalUtils/globalExports';
import {
  getReferenceDataReducer, getUserReducer,
  fetchChargerProductTypeReferenceData, fetchAlarmRules, createAlarmRule, fetchAddParameterRefChargers, fetchChargersByCustomersByOrg, fetchChargerLocationReferenceData
} from '../../rmsReduxStore/reduxExports';
import { useNavigate } from 'react-router-dom';
import { ICustomFormProps, IFormContentProp } from '../../globalUtils/CustomForm/CustomForm';
import { useLocation } from 'react-router-dom';
import { Id, toast } from 'react-toastify';
import '../users/UserForm/UserForm.css'
import { AxiosResponse } from 'axios';
import { checkValidAlphaNumericAndSymbols, createBreadCrumbProps, keyPressValidationAlphaNumericAndSymbols, } from '../../globalUtils/globalHooks';
import { CreateRuleAlertLogic, NotificationActionStatusSidePopover } from '../componentExports';
import { updateAlarmRule, fetchSingleRule, setLatestConfigurationOnTop } from '../../rmsReduxStore/configureNotificationRedux/configureNotificationCreators';
// import { Icon } from '../../globalUtils/globalIcons';
import AddIcon from '@mui/icons-material/Add';
import './CreateRule.css'
import { IconWithTooltip } from '../../globalUtils/globalIcons';
import { Button } from '@mui/material';
import { fetchSoftwarVersionReferenceData, fetchStopReasonCodeReferenceData } from '../../rmsReduxStore/referenceDataRedux/referenceDataCreators';
// import { MuiChipsInput } from 'mui-chips-input';

interface IAlarmType {
  severity: string,
  id: string,
  name: string
}

export interface SmsRecipientInterface {
  countryCode: string;
  phoneNumber: string;
}

const CreateRule: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userRoleTypeReferenceData } = useAppSelector(getReferenceDataReducer);
  const { chargerListByCustomerByOrg } = useAppSelector(getUserReducer)
  const { chargerLocationReferenceData, chargerProductTypeReferenceData, chargingStationReferenceData, chargerVisibleIdReferenceData,softwareVersionReferenceData } = useAppSelector(getReferenceDataReducer);
  const initialFormData: CreateRuleFormData = {
    name: '',
    description: '',
    chargerIds: [],
    logicComplexity: 'Basic',
    alarmTypeId: '',
    alarmContinuesFor: '',
    alarmType: { severity: '', id: '', name: '' },
    autoAssign: 'Enabled'

  }


  const [createRuleFormData, setCreateRuleFormData] = useState(initialFormData);
  const [dataList, setDataList] = useState<string[]>([])
  const [mode, setMode] = useState(location?.state?.mode ? location?.state?.mode : 'Create')
  const { customerReferenceData } = useAppSelector(getReferenceDataReducer);
  const [showLoader, setShowLoader] = useState(false);
  const [alarmList, setAlarmList] = useState<IAlarmType[]>([]);
  const [showSms, setShowSms] = useState<boolean>(false);
  const [showEmail, setShowEmail] = useState<boolean>(false);
  const handleSetShowSms = (value) => {
    setShowSms(value);
  }
  const handleSetShowEmail = (value) => {
    setShowEmail(value);
  }
  const [smsRecipients, setSmsRecipients] = useState<SmsRecipientInterface[]>([])
  const [emailRecipients, setEmailRecipients] = useState<string[]>([])
  const [smsRecipientsInitially, setSmsRecipientsInitially] = useState<SmsRecipientInterface[]>();
  const [emailRecipientsInitially, setEmailRecipientsInitially] = useState<string[]>();
  const [selectedChargersInitially, setSelectedChargersInitially] = useState<string[]>();
  const [filters, setFilters] = useState<InnerFilterState[]>(
    [{
      key: 'customer',
      value: null
    },
    {
      key: 'chargingStationId',
      value: null
    },
    {
      key: 'productType',
      value: null
    },
    {
      key: 'location',
      value: null
    },
    {
      key:'softwareVersion',
      value: null,
    }
  ])
  const [chargersChipValues, setChargersChipValues] = useState<string[]>([]);
  const [chargerCheckboxStates, setChargerCheckboxStates] = useState<string[]>([]);
  const [selectedRadioOption, setSelectedRadioOption] = useState('SelectChargers');
  const [selectedChargers, setSelectedChargers] = useState<string[]>();
  const [isSelectAllChargersChecked, setIsSelectAllChargersChecked] = useState(false)
  const orgId = JSON.parse(localStorage.getItem('rms-user') || '{}').orgId
  const [errorMessage, setErrorMessage] = useState('')
  const [errorMessageDescription, setErrorMessageDescription] = useState('')
  const [initialAlarm, setInitialAlarm] = useState('')
  const [isNotificationActionSidePopoverOpen, setIsNotificationActionSidePopoverOpen] = useState<boolean>(false);

  const isFirstHalfDisable = useCallback(() => {


    if (!createRuleFormData?.notificationTriggerIds && !createRuleFormData?.alarmTypeId && !createRuleFormData?.alarmContinuesFor) {
      return false
    }
    if ((createRuleFormData?.notificationTriggerIds?.length)) {
      return true
    }
    return false
  }, [createRuleFormData])

  const isSecondHalfDisabled = useCallback(() => {

    if (!createRuleFormData?.notificationTriggerIds?.length && !createRuleFormData?.alarmTypeId && !createRuleFormData?.alarmContinuesFor) {
      return false
    }

    console.log((createRuleFormData?.alarmTypeId && createRuleFormData?.alarmTypeId?.length > 0) || createRuleFormData?.alarmContinuesFor?.length > 0, createRuleFormData, 'tfvalue');

    if ((createRuleFormData?.alarmTypeId && createRuleFormData?.alarmTypeId?.length > 0) || createRuleFormData?.alarmContinuesFor?.toString()?.length > 0) {
      return true
    }
    return false;
  }, [createRuleFormData])

  const handleClose = () => {
    setIsNotificationActionSidePopoverOpen(false);
  }

  const handleSmsRecipientsChange = (value) => {
    setSmsRecipients(value);
  }

  const handleEmailRecipientsChange = (value) => {
    setEmailRecipients(value);
  }

  useEffect(() => {
    const chargerData = chargerListByCustomerByOrg?.map((item) => {
      return {
        header: item?.customerName,
        count: item?.chargers?.length,
        data: item?.chargers?.map((charger) => charger?.visibleId)
      }
    }) || []

    const dataList = chargerData?.flatMap(({ header, count, data }) => [
      (header !== undefined && count !== undefined) ? `${header} (${count})` : '',
      ...data
    ]).filter(item => item !== '');
    const uniqueDataList = Array.from(new Set(dataList));
    setDataList(uniqueDataList)
  }, [chargerListByCustomerByOrg])

  const handleFetchChargerProductTypes = async () => {
    try {
      const res = await dispatch(fetchChargerProductTypeReferenceData());
      const response = JSON.parse(res);

      if (response.length) {
        return response
      }
    } catch (error) {
      console.error('Error fetching charger product types:', error);
    }
  };
  const handleFetchAlarmTypes = async () => {
    try {
      const res = await dispatch(fetchAlarmRules('false'));
      const response = JSON.parse(res);

      if (response.length) {
        setAlarmList(response);
        return response
      }
    } catch (error) {
      console.error('Error fetching charger product types:', error);
    }
  };

  useEffectOnce(async () => {
    dispatch(fetchChargerLocationReferenceData())
    dispatch(fetchSoftwarVersionReferenceData())
    dispatch(fetchStopReasonCodeReferenceData())
    chargerListCallback?.(orgId)
    setShowLoader(true);
    dispatch(fetchAddParameterRefChargers())
    setMode(location?.state?.mode || 'Create')
    const alarmResponse = await handleFetchAlarmTypes()
    const responseProductTypes = await handleFetchChargerProductTypes()

    console.log(alarmResponse, responseProductTypes)
    if (mode && location?.state?.userId || location?.state?.ruleId) {
      dispatch(fetchSingleRule({}, location?.state?.userId)).then((res) => {
        setSelectedChargersInitially(res?.data?.data?.chargerIds)
        setSelectedChargers(res?.data?.data?.chargerIds)
        setChargerCheckboxStates(res?.data?.data?.chargerIds)
        handleSmsRecipientsChange(res?.data?.data?.smsRecipients),
          handleEmailRecipientsChange(res?.data?.data?.emailRecipients),
          setEmailRecipientsInitially(res?.data?.data?.emailRecipients),
          setSmsRecipientsInitially(res?.data?.data?.smsRecipients)
        setChargersChipValues(res?.data?.data?.chargerIds);
        setIsSelectAllChargersChecked(res?.data?.data?.chargerIds?.length == dataList?.filter((item) => !item.endsWith(')'))?.length)

        setCreateRuleFormData((prevState) => ({
          ...prevState,
          alarmTypeId: res?.data?.data?.notificationTriggerType == 'Stop Reasons Code' ? [] : res?.data?.data?.notificationTriggerIds,
          alarmType: res?.data?.data?.notificationTriggerType === 'Alarm' ? alarmResponse.filter(alarm => res?.data?.data?.notificationTriggerIds?.includes(alarm.id)) : null,
          autoAssign: res?.data?.data?.autoAssign,
          // occurenceTime: res?.data?.data?.notificationTriggerType === 'Alarm' ? null : res?.data?.data?.alarmContinuesFor,
          // numberOfOccurrence: res?.data?.data?.numberOfOccurrence,
          notificationTriggerIds: res?.data?.data?.notificationTriggerType === 'Alarm' ? [] : res?.data?.data?.notificationTriggerIds
        }))
        setInitialAlarm(res?.data?.data?.notificationTriggerType === 'Alarm' ? res?.data?.data?.notificationTriggerIds : null)

      })
    }
    setShowLoader(false)
  });

  useEffect(() => {
    if (location?.state?.rowData) {
      console.log('rowData wala')
      setCreateRuleFormData({
        ...createRuleFormData,
        name: location?.state?.rowData?.name || location?.state?.rowData?.ruleName,
        description: location?.state?.rowData?.description,
        alarmContinuesFor: location?.state?.rowData?.notificationTriggerType === 'Alarm' ? location?.state?.rowData?.alarmContinuesFor : null,
        notificationTriggerIds: location?.state?.rowData?.notificationTriggerType === 'Alarm' ? [] : location?.state?.rowData?.notificationTriggerIds,
        // occurenceTime: location?.state?.rowData?.notificationTriggerType === 'Alarm' ? null : location?.state?.rowData?.alarmContinuesFor,
      })
      if (location.state?.rowData?.notifyUsingEmail == 'Yes') {
        setShowEmail(true)
      }
      if (location.state?.rowData?.notifyUsingSms == 'Yes') {
        setShowSms(true)
      }
    }
  }, [])

  const handleFormDataChange = useCallback((val, formKey) => {
    const formData = cloneDeep(createRuleFormData);
    if (val?.id) {
      formData[formKey] = val?.id;
    }
    else {
      if (formKey === 'alarmTypeId' || formKey === 'notificationTriggerIds') {
        console.log(val, 'val');
        const data = val.map(item => item.id);
        formData[formKey] = data
      } else
        formData[formKey] = val;
    }
    console.log(formData, 'formData');
    setCreateRuleFormData(formData);

    if (formKey == 'name') {
      if (val.length > 90) {
        setErrorMessage('Max characters allowed are 90')
      }
      else setErrorMessage('')
      formData[formKey] = formData[formKey].charAt(0).toUpperCase() + formData[formKey].slice(1);

    }
    if (formKey == 'description') {
      if (val.length > 500) {
        setErrorMessageDescription('Max characters allowed are 500')
      }
      else setErrorMessageDescription('')
      formData[formKey] = formData[formKey].charAt(0).toUpperCase() + formData[formKey].slice(1);

    }


    // if (formKey == 'alarmType') {
    //   formData[formKey] = val;

    //   setCreateRuleFormData((prevState) => ({
    //     ...prevState,
    //     alarmTypeId: val?.id

    //   }))
    // }
    // else 
    if (formKey == 'alarmContinuesFor') {
      if(val && val <= 0){
        toast.error('\'Alarm Continues For\' field expects only positive integers.')
        formData[formKey] = null
        return;
      }
      if (val > 240) {
        toast.error('Max value can be 240 minutes.')
        formData[formKey] = null
        return;
      }

    }
  }, [createRuleFormData]);


  function arraysAreEqual<T>(arr1?: T[], arr2?: T[]): boolean {

    if (!arr2) {
      return false;
    }
    if (!arr1) {
      return false;
    }
    if (arr1.length !== arr2.length) {
      return false;
    }
    return arr1.every((value, index) => value === arr2[index]);
  }

  // const checkforOccurenceValues = useCallback(() => {
  //   if((createRuleFormData?.occurenceTime && createRuleFormData?.numberOfOccurrence) || (!createRuleFormData?.numberOfOccurrence && !createRuleFormData?.occurenceTime )){
  //     return true
  //   }
  //   else return false;
  // },[])


  const disableSubmitButton = useCallback(() => {

    if (showSms == false && showEmail == false) {
      return true
    }
    if (mode == 'Create') {
      return !(
        // Check that the name is alphanumeric and within the valid length
        (createRuleFormData?.name?.length > 0 &&
          // /^[a-zA-Z0-9\s]*$/.test(createRuleFormData.name) && // Alphanumeric check
          createRuleFormData.name.length <= 150 // Max length check
        ) &&
        (showSms || showEmail) &&
        (selectedChargers && selectedChargers?.length > 0) &&
        (isFirstHalfDisable() ? createRuleFormData?.notificationTriggerIds?.length : createRuleFormData.alarmTypeId?.length) &&
        (createRuleFormData?.description?.length <= 500) // Max total length check
        // && (checkforOccurenceValues())
      );
    }
    else if (mode == 'Edit') {

      if (createRuleFormData?.description?.length > 500) {
        return true
      }
      if (selectedChargers?.length == 0) {
        return true
      }

      if (isFirstHalfDisable()) {
        if (createRuleFormData?.notificationTriggerIds?.length == 0) {
          return true
        }
      }
      if (isSecondHalfDisabled()) {
        if (createRuleFormData?.alarmTypeId?.length == 0) {
          return true
        }
      }
      if (!isFirstHalfDisable() && !isSecondHalfDisabled()) {
        if (createRuleFormData?.alarmTypeId?.length == 0 && createRuleFormData?.notificationTriggerIds?.length == 0) {
          return true
        }
      }

      const result =
        (createRuleFormData?.name == location.state?.rowData?.name) &&
        (createRuleFormData?.description == location.state?.rowData?.description) &&
        (arraysAreEqual(selectedChargers, selectedChargersInitially)) &&
        (isSecondHalfDisabled() && createRuleFormData.alarmContinuesFor == location.state?.rowData?.alarmContinuesFor) &&
        (showEmail == (location.state?.rowData?.notifyUsingEmail == 'No' ? false : true) &&
          (showSms == (location.state?.rowData?.notifyUsingSms == 'No' ? false : true))) &&
        (arraysAreEqual(smsRecipientsInitially, smsRecipients)) &&
        (arraysAreEqual(emailRecipientsInitially, emailRecipients)) &&
        (selectedChargers && selectedChargers?.length > 0) &&
        (isSecondHalfDisabled() ? initialAlarm == createRuleFormData?.alarmTypeId : location?.state?.rowData?.notificationTriggerIds === createRuleFormData?.notificationTriggerIds)
      // (location?.state?.rowData?.numberOfOccurrence == createRuleFormData?.numberOfOccurrence)
      return result
    }
  }, [createRuleFormData, showSms, showEmail, selectedChargers, smsRecipients, emailRecipients]);

  const userFormSuccessToast = (): Id => toast.success(mode === 'Edit' ? 'Notification Rule Edited.' : 'Notification Rule Added.');

  const userFormErrorToast = (message): Id => toast.error(message);

  const footerButtonList = useMemo(() => {
    return [
      {
        buttonText: mode === 'Edit' ? 'Update' : 'Create',
        buttonId: 'submit',
        btnClassName: disableSubmitButton() ? 'primary__btn disabled' : 'primary__btn',

        handleClick: (): void => {
          handleSubmit?.(mode, showSms, showEmail)
        },
        isDisabled: disableSubmitButton(),
        buttonVariant: 'filled',
      },
      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
          navigate('/configureNotification')
        },
        isDisabled: false,
        buttonVariant: 'outlined',
      },
    ];
  }, [disableSubmitButton, createRuleFormData, mode, showSms, showEmail, selectedChargers]);

  const createRuleFormArray: IFormContentProp[] = [
    {
      rowCountClassName: '',
      sectionHeading: '',
      formObject: [
        {
          formLabel: 'Notification Name',
          isRequired: true,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: 'Type here',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphaNumericAndSymbols(event?.target?.value), 'name');
            },
            inputValue: createRuleFormData?.name,
            inputType: 'string',
            inputFieldId: 'add_user_name',
            isRequired: false,
            isDisabled: location?.state?.mode == 'Edit' ? true : false,
            autoFocus: true,
            errorMessage: errorMessage,
            handleKeyPress: keyPressValidationAlphaNumericAndSymbols,
          },
          textAreaProps: null,
          isFixedWidth: true,

        },
        {
          formLabel: 'Description',
          isRequired: false,
          objectType: 'text-area',
          selectDropdownProps: null,
          inputProps: null,
          isFixedWidth: true,
          textAreaProps: {
            inputPlaceHolder: mode !== 'View' ? 'Type here' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(event?.target?.value, 'description');
            },
            isRequired: false,
            inputValue: createRuleFormData?.description,
            inputFieldId: 'description',
            isDisabled: false,
            className: 'custom-resize',
            errorMessage: errorMessageDescription
          },
        },

      ],
    },

    // {
    //   rowCountClassName: 'grid-2',
    //   sectionHeading: '',
    //   formObject: [
    //     {
    //       formLabel: 'Description',
    //       isRequired: false,
    //       objectType: 'text-area',
    //       selectDropdownProps: null,
    //       inputProps: null,
    //       textAreaProps: {
    //         inputPlaceHolder: mode !== 'View' ? 'Type here' : '',
    //         handleInputChange: (event): void => {
    //           handleFormDataChange(event?.target?.value, 'description');
    //         },
    //         isRequired: false,
    //         inputValue: createRuleFormData?.description,
    //         inputFieldId: 'description',
    //         isDisabled: mode === 'View',
    //         className: 'custom-resize'
    //       },
    //     },
    //   ],
    // },


  ];

  const createRuleFormProps: ICustomFormProps = useMemo(() => {
    return {
      formContainerClassName: 'create__rule__name__description',
      formArray: createRuleFormArray
    };
  }, [createRuleFormData, userRoleTypeReferenceData, mode, customerReferenceData])



  const handleSubmit = useCallback(async (mode, sms, email) => {

    const reqBody = {
      name: createRuleFormData?.name,
      description: createRuleFormData?.description,
      chargerIds: selectedChargers,
      logicComplexity: (createRuleFormData?.alarmContinuesFor || createRuleFormData?.numberOfOccurrence) ? 'Advanced' : 'Basic',
      // alarmTypeId:  isFirstHalfDisable() ? null : createRuleFormData?.alarmTypeId,
      alarmContinuesFor: isFirstHalfDisable() ? parseInt(createRuleFormData?.occurenceTime ?? '') : parseInt(createRuleFormData?.alarmContinuesFor),
      notifyUsingSms: sms ? 'Yes' : 'No',
      notifyUsingEmail: email ? 'Yes' : 'No',
      id: location?.state?.userId,
      autoAssign: createRuleFormData?.autoAssign,
      smsRecipients: showSms ? smsRecipients : [],
      emailRecipients: showEmail ? emailRecipients : [],
      notificationTriggerIds: isFirstHalfDisable() ? createRuleFormData?.notificationTriggerIds : createRuleFormData?.alarmTypeId,
      notificationTriggerType: isFirstHalfDisable() ? 'Stop Reasons Code' : 'Alarm',
      // numberOfOccurrence:parseInt(createRuleFormData?.numberOfOccurrence ?? ''),
    }

    let response: AxiosResponse

    if (mode === 'Edit') {
      setShowLoader(true)
      response = await dispatch(updateAlarmRule(reqBody))
    } else {
      setShowLoader(true)
      response = await dispatch(createAlarmRule(reqBody))
    }

    if ((response?.status === 200 || response?.status === 202) && response?.data?.message === 'Success') {
      setShowLoader(false)
      userFormSuccessToast();
      await dispatch(setLatestConfigurationOnTop(true));
      navigate('/configureNotification')
    } else {
      setShowLoader(false)
      userFormErrorToast(response?.data?.message);
    }
  }, [createRuleFormData, mode, selectedChargers, smsRecipients, emailRecipients, showSms, showEmail, isFirstHalfDisable, isSecondHalfDisabled])

  const breadCrumbs = createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'createNotificationRule',
        },
        {
          objectType: 'text',
          id: 'text',
          text: mode !== 'Create' ? createRuleFormData?.name : `${mode} Notification Rule`
        }
      ]
  })

  const setHeaderText = useCallback(() => {
    if (mode == 'Create') {
      return `${mode} Notification Rule`
    } else return createRuleFormData?.name
  }, [mode, createRuleFormData])

  const chargerListCallback = useCallback((orgId, filters?, searchTerm?) => {
    let filtersToBeSent: Filters[] = []
    if (filters && filters?.length > 0) {
      filtersToBeSent = filters?.map((item) => {
        return {
          key: item.key,
          values: item.value?.map((item) => item.id) || []
        }
      })
    }
    dispatch(fetchChargersByCustomersByOrg({
      orgId: orgId,
      filters: filters ? filtersToBeSent : [],
      searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : ''
    }));
  }, [createRuleFormData])

  const handleFilterDataChange = useCallback((val, filterkey) => {
    const filtersToUpdate = cloneDeep(filters);
    const selectedFilter = filtersToUpdate?.find((filter) => filter?.key === filterkey);
    if (selectedFilter) {
      selectedFilter.value = Array.isArray(val) ? val : [val]
    }
    setFilters(filtersToUpdate);
    chargerListCallback?.(orgId, filtersToUpdate, '')
  }, [filters, chargerListCallback, setFilters, createRuleFormData])

  const onSearchTextChange = useCallback((val) => {
    chargerListCallback?.(orgId, filters, val)
  }, [filters, createRuleFormData])

  const searchBoxConfiguration = useMemo(() => {
    return {
      searchFieldId: 'user__form_chargers-search-box',
      searchFieldName: 'user__form_chargers-search-box',
      isDisabled: mode === 'View',
      handleSearch: onSearchTextChange,
      searchBoxClassName: 'create__configure__notification__rule__charger_selection'
    };
  }, [onSearchTextChange, filters, createRuleFormData, mode]);

  const radioButtonList = [
    { radioButtonLabel: 'All Chargers', radioButtonId: 'AllChargers', isDisabled: mode === 'View' },
    { radioButtonLabel: 'Select Chargers', radioButtonId: 'SelectChargers', isDisabled: mode === 'View' },
  ]

  const chargerFilterProps: FilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: 'Customer',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'customer')?.value,
          selectOptions: customerReferenceData?.filter((customer) => customer?.id === 'all' || chargerVisibleIdReferenceData?.some((charger) => charger?.customerId === customer?.id)) ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'customer')
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true,
        }
      },
      {
        filterLabel: 'Location',
        filterType: 'dropdown',
        filterId: 'Location',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'location')?.value,
          selectOptions: chargerLocationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'location')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },

      {
        filterLabel: 'Charging Station',
        filterType: 'dropdown',
        filterId: 'chargingStationId',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'chargingStationId')?.value,
          selectOptions: chargingStationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'chargingStationId')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Product Type',
        filterType: 'dropdown',
        filterId: 'ProductType',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'productType')?.value,
          selectOptions: chargerProductTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'productType')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Software Version',
        filterType: 'dropdown',
        filterId: 'softwareVersion',
        filterDropdownProps: {
            selectValue: filters?.find((filter) => filter?.key === 'softwareVersion')?.value,
            selectOptions: softwareVersionReferenceData ?? [],
            handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'softwareVersion')
            },
            selectDropDownId: 'charger-customer-filter-dropdown-rule-engine',
            isMultiSelect: true,
            isDisabled: false,
            renderToBody: true
        }
      },
    ]
  }, [chargerLocationReferenceData, customerReferenceData, filters, mode, createRuleFormData, softwareVersionReferenceData])

  const handleSelectedValues = (selectedChargers, selectedChargerChips, isChecked) => {
    setChargerCheckboxStates(selectedChargers)
    setSelectedChargers(selectedChargers);
    setChargersChipValues(selectedChargerChips);
    setIsSelectAllChargersChecked(isChecked)
  };
  const handleRadioOptionChange = (_, value) => {
    setSelectedRadioOption(value);
    if (value === 'AllChargers') setSelectedChargers(['ALL'])
    else { setSelectedChargers(chargerCheckboxStates) }
  };

  const radioButtonConfiguration = useMemo(() => {
    return {
      radionBtnGrpName: 'user__form_charger_options',
      buttonsList: radioButtonList,
      selectedRadioBtnValue: selectedRadioOption,
      handleSelectedRadioBtnChange: handleRadioOptionChange

    };
  }, [createRuleFormData, mode, selectedRadioOption, chargerCheckboxStates]);

  const handleNotificationActionClick = () => {
    setIsNotificationActionSidePopoverOpen(true)
  }

  const handleCloseNotificationActionStatusClosePopover = () => {
    setIsNotificationActionSidePopoverOpen(false)
  }



  return (
    <>
      <DashboardLoader showLoader={showLoader} />
      <div className='user__form__wrap configure__notification'>
        <CustomBreadCrumbs breadCrumbs={breadCrumbs} />
        <div className='user__form__wrap-header-custom'>

          <DashboardHeader
            header={setHeaderText()}
            headerClassName='user__form__wrap-header-text'
          />
          {/* {mode !== 'Create' && (

            <Icon
              iconClassName={mode === 'View' ? 'rms__pencil__icon' : 'rms__view__icon'}
              containerClassName='org__form_header-edit'
              onIconClick={() => {
                // if (mode === 'Edit') {}
                setMode(mode === 'View' ? 'Edit' : 'View')
              }
              }
            />

          )} */}
        </div>
        <div className='user__form__wrap-content'>
          <CustomForm {...createRuleFormProps} />
          <CreateRuleAlertLogic
            createRuleFormData={createRuleFormData}
            handleFormDataChange={handleFormDataChange}
            isFirstHalfDisable={isFirstHalfDisable}
            isSecondHalfDisabled={isSecondHalfDisabled}
            selectDropdownProps={{
              isMultiSelect: true,
              selectValue: alarmList?.filter((item) => createRuleFormData?.alarmTypeId?.includes(item?.id)),
              selectOptions: (alarmList),
              handleSelectOptionChange: (val): void => {
                handleFormDataChange(val, 'alarmTypeId');
              },
              selectDropDownId: 'user-role-type-dropdown',
              selectDropDownName: 'user-role-type-dropdown',
              isDisabled: false,

              renderToBody: true,

            }}
            inputProps={{
              inputPlaceHolder: 'Type here',
              handleInputChange: (event): void => {
                handleFormDataChange(event?.target?.value, 'alarmContinuesFor');
              },
              inputValue: createRuleFormData?.alarmContinuesFor,
              inputType: 'string',
              inputFieldId: 'alarm_continues_for',
              isRequired: false,
              isDisabled: false,
            }}
            formLabel='Alarm'
            isRequired />
          <CustomRadioForm
            formContainerClass={'user__form__charger-selection'}
            header={'Charger Selection*'}
            dataList={dataList || []}
            individualCheckboxStates={chargerCheckboxStates}
            selectedChipValues={chargersChipValues}
            selectAllChecked={isSelectAllChargersChecked}
            handleSelectedData={handleSelectedValues}
            filterProps={chargerFilterProps}
            radioButtonConfiguration={radioButtonConfiguration}
            smallerFont={true}
            searchBoxConfiguration={searchBoxConfiguration}
            disableCheckBox={mode === 'View'}
            showRadioList={selectedRadioOption === 'SelectChargers'}
            isCustom={true}
            radioButtonConfigNotRequired={true}
            removePadding={true}
          />


          <div className='user__form__wrap-footer-top'>
            <div className='user__form__wrap-footer-top-checkbox' onClick={() => { mode !== 'View' && handleFormDataChange(createRuleFormData?.autoAssign === 'Enabled' ? 'Disabled' : 'Enabled', 'autoAssign') }} >
              <CheckBox checked={createRuleFormData?.autoAssign === 'Enabled'} isDisabled={mode === 'View'} />
              Auto assign new charger to this user
            </div>
            <IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={'RMS will automatically assign any new charger to this user.'} containerClassName='user__form_footer-auto-assign-info' />
          </div>

          {/* <CreateRuleNotificationAction
            showSms={showSms}
            showEmail={showEmail}
            setShowSms={setShowSms}
            setShowEmail={setShowEmail}
            disable={mode == 'View' ? true : false} */}
          {/* /> */}
          {(showSms === true) || (showEmail === true) ?
            <div>
              <div className='custom__form__wrap-header-text-title row__label'>
                Notification Action*
                <IconWithTooltip iconClassName={'define-execution-edit-pencil-sidebar edit__button'} onIconClick={handleNotificationActionClick} />
              </div>
              {showSms && <div className='notification__action__row__label'> SMS : {smsRecipients && smsRecipients.length} Recipients</div>}
              {showEmail && <div className='notification__action__row__label'> Email : {emailRecipients && emailRecipients.length} Recipients</div>}
            </div> : <Button
              startIcon={<AddIcon />}
              sx={{ color: '#49c8d1', textTransform: 'none', fontSize: '1rem', marginTop: '30px' }}
              onClick={handleNotificationActionClick}
            >
              Notification Action*
            </Button>}
          {/* <MuiChipsInput value={chips} onChange={handleChange} /> */}

        </div>
        <div className='user__form__wrap-footer'>
          <CustomButtonGroup
            buttonsList={mode === 'View' ? footerButtonList?.filter((button) => button?.buttonId === 'cancel') : footerButtonList}

            buttonGroupClassName='button__group__footer'
          />
        </div>

      </div>
      {isNotificationActionSidePopoverOpen && <SidePopover
        id='configure__notification__form__notification__action__status__popover'
        open={isNotificationActionSidePopoverOpen}
        headerText={'Notification Action'}
        containerClassName='configure__notification__detail__popover'
        handleClose={() => { }}
        headerSecondaryText={'Email/SMS Message'}
        horizontalLinePopover={true}
        popperClassName='rule__engine__raise__a__ticket'
        isRuleEnginePopOver={true}
        headerClassName={'rule__engine__header__config'}
        ruleEngineSidePopoverOnclose={handleCloseNotificationActionStatusClosePopover}


        // eslint-disable-next-line react/no-children-prop
        children={
          <>
            {
              <NotificationActionStatusSidePopover

                handleClose={handleClose}
                showSms={showSms}
                handleSetShowSms={handleSetShowSms}
                showEmail={showEmail}
                handleSetShowEmail={handleSetShowEmail}
                smsRecipients={smsRecipients}
                handleSmsRecipientsChange={handleSmsRecipientsChange}
                emailRecipients={emailRecipients}
                handleEmailRecipientsChange={handleEmailRecipientsChange}
              />
            }
          </>
        }
      />
      }

    </>
  );
};

export default CreateRule;
